import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { JoinPlatformButton } from './JoinPlatformButton';
import { practitionerApplicationUrl } from '../data/appTour';
export function FinalCTA() {
  return <Section background="charcoal" className="text-center py-32" data-id="element-159" data-mp="856zj8k1inrk">
      <div className="max-w-3xl mx-auto" data-id="element-160" data-mp="83vwxc2bzm21">
        <FadeIn data-id="element-161" data-mp="m4ovq8zo13ay">
          <h2 className="text-5xl md:text-6xl font-serif text-ivory mb-8" data-id="element-162" data-mp="m46q4lr45cqd">
            Join the Next Era of Wellness
          </h2>
          <p className="text-xl text-ivory/70 mb-12 font-light" data-id="element-163" data-mp="h5c65gheti4o">
            Whether you are seeking care, providing care, or investing in the
            future of care — there is a place for you here.
          </p>
        </FadeIn>

        <FadeIn delay={200} className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6" data-id="element-164" data-mp="14vfyust27xgw">
          <JoinPlatformButton className="w-full sm:w-auto bg-purple-600 text-white hover:bg-purple-700" data-id="element-165" data-mp="zxehqdf72882" />
          <a href={practitionerApplicationUrl} target="_blank" rel="noopener noreferrer" data-id="element-166" data-mp="2c5puvpiev1zj">
            <Button variant="outline" size="lg" className="w-full sm:w-auto border-ivory text-ivory hover:bg-ivory hover:text-charcoal" data-id="element-167" data-mp="2h5u6p28dj8jf">
              Apply to Network
            </Button>
          </a>
        </FadeIn>
      </div>
    </Section>;
}